import { render } from "./MostRecentContribution.vue?vue&type=template&id=34972aa0&ts=true"
import script from "./MostRecentContribution.vue?vue&type=script&lang=ts"
export * from "./MostRecentContribution.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__